/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function assignFilter(filter, target) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var filteredArgs = args.map(function (obj) {
    if (obj == null) {
      return obj;
    }
    return Object.keys(obj).reduce(function (acc, propName) {
      var value = obj[propName];
      if (filter(value, propName, obj)) {
        acc[propName] = value;
      }
      return acc;
    }, {});
  });
  return Object.assign.apply(Object, [target].concat((0, _toConsumableArray2.default)(filteredArgs)));
}
var _default = assignFilter;
exports.default = _default;